export const VISITOR_MESSAGE_API_METHODS = {
  topics: 'client/visitor/message/topics',
  list: 'client/visitor/message/list',
  find: 'client/visitor/message/find',
  send: 'client/visitor/message/send',
  listUnread: 'client/visitor/message/list_unread',
  hadRead: 'client/visitor/message/had_read',
  popupMessages: 'client/visitor/message/popup_messages',
  topicFind: 'client/visitor/message/topic_find',
} as const

export const VISITOR_MESSAGE_API_NOTICES = {
  create: 'client/visitor/message/create',
  hadRead: 'client/visitor/message/had_read',
} as const

export const DASHBOARD_MESSAGES_SHOW_LIMIT = 2
